@let entries = items();

<!-- Mobile: dropdown picker (trigger shows the title only) -->
<div class="flex flex-col gap-1 border-b border-border-secondary px-6 py-3 sm:hidden">
  @if (label()) {
    <span class="text-text-secondary" tuiTitle="s">{{ label() }}</span>
  }
  <button
    appearance="outline"
    class="w-full justify-between"
    tuiButton
    tuiChevron
    type="button"
    [attr.aria-expanded]="isOpen()"
    [tuiDropdown]="dropdown"
    [tuiDropdownManual]="isOpen()"
    [tuiObscuredEnabled]="isOpen()"
    (click)="isOpen.set(!isOpen())"
    (tuiActiveZoneChange)="isOpen.set($event && isOpen())"
    (tuiObscured)="$event && isOpen.set(false)">
    {{ entries[selectedIndex()].title }}
  </button>
  <ng-template #dropdown>
    <tui-data-list>
      @for (item of entries; track $index) {
        <button tuiOption type="button" (click)="select($index)">
          <span tuiTitle>
            {{ item.title }}
            @if (item.subtitle) {
              <span tuiSubtitle>{{ item.subtitle }}</span>
            }
          </span>
        </button>
      }
    </tui-data-list>
  </ng-template>
</div>

<!-- Desktop: sidebar list -->
<div class="hidden shrink-0 flex-col gap-2 border-r border-border-secondary pt-4 sm:flex sm:w-64">
  @if (label()) {
    <p class="text-text-secondary px-6" tuiTitle="s">{{ label() }}</p>
  }
  <tui-scrollbar class="min-h-0 flex-1" tuiFade="vertical">
    <div class="flex flex-col divide-y divide-border-tertiary">
      @for (item of entries; track $index) {
        @let isActive = selectedIndex() === $index;
        <button
          class="flex flex-col items-start gap-0.5 px-6 py-2 text-left text-sm transition-colors"
          type="button"
          [class.bg-background-brand-secondary/50]="isActive"
          (click)="select($index)">
          <span
            class="font-medium"
            [class.text-text-brand-secondary]="isActive"
            [class.text-text-secondary]="!isActive">
            {{ item.title }}
          </span>
          @if (item.subtitle) {
            <span class="text-xs" [class.text-text-brand-tertiary]="isActive" [class.text-text-tertiary]="!isActive">
              {{ item.subtitle }}
            </span>
          }
        </button>
      }
    </div>
  </tui-scrollbar>
</div>
